module.exports = __webpack_public_path__ + "img/service_6.6ac6a8f5.png";